import React from 'react';
import { Draggable } from '../DragAndDrop/Draggable';
import { dataHooks } from './constants';
export default Component => {
    const withDNDContext = props => (React.createElement("div", { "data-hook": props.dataHook },
        React.createElement(Draggable.Manager, { dataHook: dataHooks.provider },
            React.createElement(Component, { ...props }))));
    withDNDContext.displayName = Component.displayName;
    return withDNDContext;
};
//# sourceMappingURL=withDNDContext.js.map